// Títulos que se desbloquean al completar todas las actividades de un libro
export const BOOK_TITLES: { [bookNumber: number]: string } = {
    1: "Ministro de la Verdad",
    2: "Peregrino Pensador", 
    3: "Defensor del Bien Común",
    4: "Subalcalde",
    5: "Maestro de la Transformación",
    6: "Jefe de Proyectos",
    7: "Maestro de la Vitalidad",
    8: "Director de Desarrollo y Financiación"
};

// Función para obtener el título de un libro específico
export function getBookTitle(bookNumber: number): string {
    return BOOK_TITLES[bookNumber] || `Libro ${bookNumber}`;
}

// Función para obtener todos los títulos desbloqueados de un niño
export function getUnlockedTitles(booksOverview: any): string[] {
    if (!booksOverview || !booksOverview.books) {
        return [];
    }
    
    const unlockedTitles: string[] = [];
    
    booksOverview.books.forEach((book: any) => {
        if (book.is_unlocked) {
            // Verificar si todas las actividades del libro están aprobadas
            const allActivitiesApproved = book.activities.every((activity: any) => 
                activity.status === 'approved'
            );
            
            if (allActivitiesApproved) {
                unlockedTitles.push(getBookTitle(book.book_number));
            }
        }
    });
    
    return unlockedTitles;
}

// Función para obtener el título más alto (último libro completado)
export function getHighestTitle(booksOverview: any): string | null {
    const unlockedTitles = getUnlockedTitles(booksOverview);
    if (unlockedTitles.length === 0) {
        return null;
    }
    
    // Retornar el título del libro con número más alto
    return unlockedTitles[unlockedTitles.length - 1];
}

// Función para obtener el color del título basado en el libro
export function getTitleColor(bookNumber: number): string {
    const colors = {
        1: "from-blue-500 to-blue-600",      // Azul para Ministro de la Verdad
        2: "from-green-500 to-green-600",   // Verde para Peregrino Pensador
        3: "from-purple-500 to-purple-600", // Púrpura para Defensor del Bien Común
        4: "from-yellow-500 to-yellow-600", // Amarillo para Subalcalde
        5: "from-red-500 to-red-600",       // Rojo para Maestro de la Transformación
        6: "from-indigo-500 to-indigo-600", // Índigo para Jefe de Proyectos
        7: "from-pink-500 to-pink-600",     // Rosa para Maestro de la Vitalidad
        8: "from-orange-500 to-orange-600"  // Naranja para Director de Desarrollo
    };
    
    return colors[bookNumber as keyof typeof colors] || "from-gray-500 to-gray-600";
}
